import Link from 'next/link'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'

import { convertBreadcrumb } from '@helpers/convertBreadcrumb'

import { BreadcrumbItem, BreadcrumbList } from './styles'
import { BreadcrumbProps, BreadcrumbsPaths } from './types'

export function Breadcrumb({ transformLabel, textColor }: BreadcrumbProps) {
  const router = useRouter()
  const [breadcrumbs, setBreadcrumbs] = useState<BreadcrumbsPaths[]>([])

  useEffect(() => {
    if (router) {
      const linkPath = router.asPath.split('/')
      linkPath.shift()

      const pathArray = linkPath.map((path, i) => ({
        breadcrumb: path,
        href: `/${linkPath.slice(0, i + 1).join('/')}`,
      }))

      setBreadcrumbs(pathArray)
    }
  }, [router])

  if (!breadcrumbs.length) {
    return null
  }

  return (
    <BreadcrumbList>
      <BreadcrumbItem textColor="none" />
      {breadcrumbs.length >= 1 &&
        breadcrumbs.map(breadcrumb => {
          if (!breadcrumb || breadcrumb.breadcrumb.length === 0) {
            return
          }
          return (
            <BreadcrumbItem key={breadcrumb.href} textColor={textColor}>
              <Link href={breadcrumb.href}>
                {convertBreadcrumb(
                  breadcrumb.breadcrumb,
                  false,
                  [],
                  transformLabel
                )}
              </Link>
            </BreadcrumbItem>
          )
        })}
    </BreadcrumbList>
  )
}
